import { useEffect, useState } from 'react';
import { useReduxStore } from '../../../hooks/useReduxStore';
import { useNavigate } from 'react-router-dom';
import { GetTicketsAction, UpdateTicketStatusAction } from '../../../store/Sagas/Admin/adminSupportSaga';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function SupportList() {
  const { getState, dispatch } = useReduxStore();
  const navigate = useNavigate();
  const { tickets, loading, total, page, pages, limit } = getState('ADMIN_SUPPORT');

  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    dispatch(GetTicketsAction({ page: 1, limit: 10 }));
  }, [dispatch]);

  const handleSearch = () => {
    dispatch(GetTicketsAction({ page: 1, limit: limit || 10, search, status }));
  };

  const updateStatus = (ticketId, newStatus) => {
    dispatch(UpdateTicketStatusAction({ ticketId, status: newStatus }));
  };

  const handlePage = (p) => {
    dispatch(GetTicketsAction({ page: p, limit: limit || 10, search, status }));
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white">Support Tickets</h1>
        <div className="text-sm text-gray-400">Total: <span className="text-primaryBlue font-semibold">{total}</span></div>
      </div>

      {/* <div className="  p-6 px-0">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
          <div className="md:col-span-6 relative">
            <MagnifyingGlassIcon className="h-5 w-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by subject or user..." className="w-full pl-10 pr-4 py-4 bg-blueGray border border-borderGray rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-primaryBlue" />
          </div>
          <div className="md:col-span-3">
            <select value={status} onChange={(e) => setStatus(e.target.value)} className="w-full px-4 py-4 bg-blueGray border border-borderGray rounded-lg text-white focus:outline-none focus:border-primaryBlue">
              <option value="">All Status</option>
              <option value="open">Open</option>
              <option value="in_progress">In Progress</option>
              <option value="closed">Closed</option>
            </select>
          </div>
          <div className="md:col-span-2 flex gap-2">
            <button onClick={handleSearch} className="px-4 py-4 bg-blueGray border border-borderGray text-white rounded-lg">Search</button>
            <button onClick={() => { setSearch(''); setStatus(''); dispatch(GetTicketsAction({ page: 1, limit: 10 })); }} className="px-4 py-4 bg-blueGray border border-borderGray text-white rounded-lg">Clear</button>
          </div>
        </div>
      </div> */}

      <div className="bg-blueGray border-2 border-borderGray rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-blueGray border-b border-borderGray">
              <tr>
                <th className="px-6 py-4 text-left text-base font-medium text-white uppercase tracking-wider">Ticket ID</th>
                <th className="px-6 py-4 text-left text-base font-medium text-white uppercase tracking-wider">Subject</th>
                <th className="px-6 py-4 text-left text-base font-medium text-white uppercase tracking-wider">User</th>
                <th className="px-6 py-4 text-left text-base font-medium text-white uppercase tracking-wider">Status</th>
                <th className="px-6 py-4 text-left text-base font-medium text-white uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-borderGray">
              {loading ? (
                <tr><td colSpan="5" className="px-6 py-8 text-center text-gray-400">Loading tickets...</td></tr>
              ) : tickets.length === 0 ? (
                <tr><td colSpan="5" className="px-6 py-8 text-center text-gray-400">No tickets found</td></tr>
              ) : tickets?.map((t) => (
                <tr key={t._id} className="hover:bg-blueGray/50">
                  <td className="px-6 py-4 whitespace-nowrap text-white">#{t._id.substring(0,8)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-white">{t.subject}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-white">{t.user?.email || '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap capitalize text-white">{t.status}</td>
                  <td className="px-6 py-4 whitespace-nowrap flex gap-2">
                    <button onClick={() => navigate('/Admin/Dashboard/Support/Detail', { state: { ticket: t } })} className="px-3 py-1 bg-primaryBlue text-white rounded">View</button>
                    <select value={t.status} onChange={(e) => updateStatus(t._id, e.target.value)} className="px-2 py-1 bg-blueGray border border-borderGray rounded text-white">
                      <option value="open">Open</option>
                      <option value="in_progress">In Progress</option>
                      <option value="closed">Closed</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {pages > 1 && (
        <div className="flex items-center justify-between bg-blueGray border-2 border-borderGray rounded-lg p-4">
          <div className="text-sm text-gray-400">Page {page} of {pages} ({total} total)</div>
          <div className="flex gap-2">
            <button disabled={page===1} onClick={()=>handlePage(page-1)} className="px-3 py-2 bg-blueGray text-white rounded disabled:opacity-50">Prev</button>
            <button disabled={page===pages} onClick={()=>handlePage(page+1)} className="px-3 py-2 bg-blueGray text-white rounded disabled:opacity-50">Next</button>
          </div>
        </div>
      )}
    </div>
  );
}


